define([
  "jquery"],
function ($) {

  "use strict";

  // Allows specific offsets by target
  var offsets = {
    testimonials: 0
  };

  /**
   * This file provides smooth scrolling for links pointed to same page targets.
   */
  $(function() {
    $(document).on("click", "a[href^='#']", function(event) {
      var target = $(this).attr("href").substr($(this).attr("href").indexOf("#") + 1);
      if (target === "BVRRWidgetID") {
        target = "testimonials";
      } else {
        event.preventDefault();
      }

      var offset = offsets[target] !== undefined ? offsets[target] : 50;
      if ($(this).attr("data-offset")) {
        offset = $(this).attr("data-offset");
      }
      if ($("#" + target).attr("id") != "gcc-product-gallery-detail") {
        if ($("#" + target).length > 0) {
          $("html, body").animate({
            scrollTop: $("#" + target).offset().top - offset
          }, 1000);
        }
      }
    });
  });

});
